import { constants } from "./constants";
import { service } from "./service";
import { Dispatch } from "redux";

export const actions = {
  login,
  getPractice,
  getPracticeAdmin,
  loginLexiaTools,
};

function loginLexiaTools(token, email) {
  const data = {
    token: token,
    email: email,
  };

  return function (dispatch) {
    dispatch(request());

    service.loginTools(data).then(
      function (data) {
        if (!data) return;
        dispatch(success(data));
      },
      function failure(error) {
        return {
          type: constants.LOGIN_FAILURE,
          payload: JSON.stringify(error),
        };
      },
    );
  };

  function request() {
    return { type: constants.LOGIN_REQUEST };
  }

  function success(data) {
    return { type: constants.LOGIN_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: constants.LOGIN_FAILURE, payload: error };
  }
}

function login(email, password) {
  const data = {
    email: email,
    password: password,
  };

  return function (dispatch) {
    dispatch(request());

    service.login(data).then(
      function (data) {
        dispatch(success(data));
      },
      function failure(error) {
        return {
          type: constants.LOGIN_FAILURE,
          payload: JSON.stringify(error),
        };
      },
    );
  };

  function request() {
    return { type: constants.LOGIN_REQUEST };
  }

  function success(data) {
    return { type: constants.LOGIN_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: constants.LOGIN_FAILURE, payload: error };
  }
}

export const logout = () => (dispatch) => {
  dispatch({ type: constants.LOGOUT_REQUEST });
  try {
    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: constants.LOGOUT_SUCCESS });
  } catch (error) {
    dispatch({
      type: constants.LOGOUT_FAILURE,
      payload: { error: "Errore durante il logout" },
    });
  }
};

function getPractice() {
  return function (dispatch) {
    dispatch(request());

    service.getPractice().then(
      function (data) {
        dispatch(success(data));
      },
      function (error) {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: constants.PRACTICE_GET_REQUEST };
  }

  function success(data) {
    return { type: constants.PRACTICE_GET_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: constants.PRACTICE_GET_FAILURE, payload: error };
  }
}

function getPracticeAdmin() {
  return function (dispatch) {
    dispatch(request());

    service.getPracticeAdmin().then(
      function (data) {
        dispatch(success(data));
      },
      function (error) {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: constants.PRACTICE_GET_REQUEST };
  }

  function success(data) {
    return { type: constants.PRACTICE_GET_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: constants.PRACTICE_GET_FAILURE, payload: error };
  }
}
